/**
 * Shared helpers for the admin tabs.
 */
import { adminApi } from "../../lib/api";
import { toast } from "sonner";

export const STATUS_FLOW = ["pending", "paid", "packed", "shipped", "delivered"];

export const nextStatus = (s) => {
  const i = STATUS_FLOW.indexOf(s);
  return i >= 0 && i < STATUS_FLOW.length - 1 ? STATUS_FLOW[i + 1] : null;
};

/**
 * bulkDelete — POSTs { ids } to `endpoint`, shows toast, resets selection, reloads list.
 */
export const bulkDelete = async (endpoint, ids, reloadFn, setSelected, label = "items", toTrash = false) => {
  if (!ids.length) return;
  if (!window.confirm(toTrash
    ? `Move ${ids.length} ${label} to Recently Deleted?\n\nYou can restore them within 30 days from the Recently Deleted tab.`
    : `Delete ${ids.length} ${label}?`)) return;
  try {
    const r = await adminApi().post(endpoint, { ids });
    toast.success(toTrash ? `Moved ${r.data.deleted} to Recently Deleted` : `Deleted ${r.data.deleted}`);
    setSelected(new Set());
    reloadFn();
  } catch (err) {
    toast.error(err?.response?.data?.detail || "Bulk delete failed");
  }
};
